import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { MainText } from "../MainText";
import { SelectedInputProps } from "./types";

const styles = StyleSheet.create({
  main: {
    width: "100%",
    flex: 1,
    flexDirection: "column",
  },
});

const InputSelected = ({
  onPress = () => {},
  placeholderText = "",
  stylePlaceholderText = {}, // style not use now
  selectedText = "",
}: SelectedInputProps) => {
  return (
    <TouchableOpacity style={styles.main} onPress={onPress}>
      <MainText variant="l3-bold" color="brand.500">
        {placeholderText}
      </MainText>
      {selectedText !== "" && (
        <MainText variant="l4-medium">{selectedText}</MainText>
      )}
    </TouchableOpacity>
  );
};

export { InputSelected };
